import { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'react-feather';
import classes from './CardsPerRowDropdown.module.css';

interface CardsPerRowOption {
  value: number;
  label: string;
  sublabel: string;
}

const OPTIONS: CardsPerRowOption[] = [
  { value: 2, label: '2 per row', sublabel: 'Default' },
  { value: 3, label: '3 per row', sublabel: 'Expanded' },
  { value: 4, label: '4 per row', sublabel: 'Condensed' },
  { value: 5, label: '5 per row', sublabel: 'Compact' },
];

interface CardsPerRowDropdownProps {
  value: number;
  onChange: (value: number) => void;
}

export function CardsPerRowDropdown({ value, onChange }: CardsPerRowDropdownProps) {
  const [opened, setOpened] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on outside click
  useEffect(() => {
    if (!opened) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpened(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [opened]);

  const renderBars = (count: number, active: boolean) => (
    <div className={active ? classes.triggerBars : classes.optionBars}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={active ? classes.triggerBar : `${classes.optionBar} ${classes.optionBarActive}`}
          style={{ height: `${8 + i * 2}px` }}
        />
      ))}
    </div>
  );

  return (
    <div className={classes.dropdown} ref={ref}>
      <button
        type="button"
        className={classes.trigger}
        onClick={() => setOpened(!opened)}
      >
        {renderBars(value, true)}
        <span>{value} per row</span>
        <ChevronDown size={14} />
      </button>

      {opened && (
        <div className={classes.menu}>
          {OPTIONS.map((option) => (
            <div
              key={option.value}
              className={`${classes.option} ${option.value === value ? classes.optionSelected : ''}`}
              onClick={() => {
                onChange(option.value);
                setOpened(false);
              }}
            >
              {renderBars(option.value, false)}
              <span className={classes.optionLabel}>{option.label}</span>
              <span className={classes.optionSublabel}>{option.sublabel}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
